import AIServiceLayout from './AIServiceLayout';
import SoftwareEngineeringLayout from './SoftwareEngineeringLayout';
import CloudInfrastructureLayout from './CloudInfrastructureLayout';
import DataAnalyticsLayout from './DataAnalyticsLayout';

import ConsultingLayout from './ConsultingLayout';
import CXTransformationLayout from './CXTransformationLayout';
import IntelligentAutomationLayout from './IntelligentAutomationLayout';
import EnterpriseSecurityLayout from './EnterpriseSecurityLayout';
import ApplicationDevelopmentLayout from './ApplicationDevelopmentLayout';
import EnterpriseIntegrationLayout from './EnterpriseIntegrationLayout';
import GlobalCapabilityCentersLayout from './GlobalCapabilityCentersLayout';
import OpenSourceLayout from './OpenSourceLayout';
import ExperienceTransformationLayout from './ExperienceTransformationLayout';
import CXContactCenterLayout from './CXContactCenterLayout';

const servicePageMap = {
    'ai-services': AIServiceLayout,
    'software-product-engineering': SoftwareEngineeringLayout,
    'cloud-infrastructure': CloudInfrastructureLayout,
    'data-analytics': DataAnalyticsLayout,

    'consulting': ConsultingLayout,
    'cx-transformation': CXTransformationLayout,
    'intelligent-automation': IntelligentAutomationLayout,
    'enterprise-security': EnterpriseSecurityLayout,
    'application-development': ApplicationDevelopmentLayout,
    'enterprise-integration': EnterpriseIntegrationLayout,
    'global-capability-centers': GlobalCapabilityCentersLayout,
    'open-source': OpenSourceLayout,
    'experience-transformation': ExperienceTransformationLayout,
    'cx-contact-center': CXContactCenterLayout,
};

export default servicePageMap;
